var xP = require('../xP');

module.exports = {
  name: 'changed', base: '_rooted', prototype: {
    init: function (params, control) {
      xP.dependencies.changed.base.init.apply(this, arguments);

      var that = this;
    },

    process: function () {
      if (!this.to) {
        return;
      } // TODO: Надо разобраться с destroy.
      xP.debug('changed', 'changed', this.to.first().$element, this.to);

      var that = this;

      this.to.each(function () {
        // TODO: Разобраться с этой строчкой. Можно оптимизировать.
        var cur = this.val(),//this._param('value'),
          ini = this._param('initial_value');

        that.result = (ini === undefined ? '' : ini) != cur;

        this.$container.toggleClass(
          that.container_changed_class,
          that.result
        );

        that.to_root(that.result);

        var parent = this.parent();

        if (parent) {
          parent.change();
        }
      });
    },

    container_changed_class: 'changed'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dependencies/changed.js
 ** module id = 41
 ** module chunks = 0
 **/